export default "__VITE_ASSET__462845d9__"